/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestMaxTimeCommandSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_MAX_TIME_COMMAND')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class AutoTestMaxTimeCommandSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestMaxTimeCommandSettingParser.decode(input).map(res => new AutoTestMaxTimeCommandSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestMaxTimeCommandSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestMaxTimeCommandSettingParser.encode(data);
    }
    static schema() {
        return AutoTestMaxTimeCommandSettingParser.schema();
    }
}
